import React, { useState } from "react";
import s from "./AddCar.module.scss";
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  Row,
  Select,
  Upload,
  message,
} from "antd";
import { PlusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { addCar, getMyCars } from "../../redux/carSlice";
import {
  availableOptions,
  bodyTypeOptions,
  colorsOptions,
  conditionOptions,
  currency,
  driveTypeOptions,
  fuelTypesOptions,
  inStock,
  locationOptions,
  rangeFuelVolume,
  rangeYear,
  transmissionOptions,
  wheelOptions,
} from "../../data";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useTranslation } from "react-i18next";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
  });

const AddCar = () => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [selectedBrand, setSelectedBrand] = useState();
  const [modelsByBrand, setModelsByBrand] = useState();
  const [modelValue, setModelValue] = useState();
  const brands = useSelector((state) => state.cars.brandList);
  const models = useSelector((state) => state.cars.modelList);
  const [activeSubcategories, setActiveSubcategories] = useState();
  const [activeCategory, setActiveCategory] = useState();
  const [activeSubCategory, setActiveSubcategory] = useState();
  const carTypes = useSelector((state) => state.cars.categories);
  const [messageApi, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.cars.locations);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [file, setFile] = useState([]);
  const navigate = useNavigate();
  const [value, setValue] = useState("");
  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Вы добавили объявление о продаже авто!",
    });
  };

  const selectModels = (value) => {
    const data = models.filter((it) => it.brand.id === value);
    setModelsByBrand(data);
  };

  const selectSubcategories = (value) => {
    const data = carTypes.find((it) => it.id === value)?.sub_types;
    setActiveSubcategories(data);
  };

  const currentYear = new Date().getFullYear();
  const years = rangeYear(currentYear, currentYear - 50, -1);
  const fuelVolume = rangeFuelVolume(0.5, 6, 0.1);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type='button'
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("upload")}
      </div>
    </button>
  );

  const sendForm = async (values) => {
    const data = new FormData();
    data.append("vehicle_type", values.category);
    data.append("sub_vehicle_type", values.vechicle_type);
    data.append("brand", values.brand);
    data.append("model", values.model);
    data.append("year_of_manufacture", values.year);
    data.append("body_type", values.body_type);
    data.append("generation", values.generation);
    data.append("fuel_type", values.fuel);
    data.append("drive_type", values.drive_type);
    data.append("transmission", values.transmission);
    data.append("steering_wheel", values.wheel);
    data.append("engine", values.volume);
    data.append("color", values.color);
    data.append("condition", values.condition);
    data.append("mileage", values.mileage);
    data.append("availability", values.inStock);
    data.append("seller_comment", value);
    data.append("customs_clearance", values.customControl);
    data.append("registration", values.registration);
    data.append("vincode", values.vincode);
    data.append("installment", values.installment);
    data.append("price", values.price);
    data.append("currency", values.currency.value);
    data.append("phone", values.phone);
    data.append("location", values.location);

    if (file && file.length > 0) {
      file.forEach((it) => {
        data.append("images", it.originFileObj);
      });
    }

    const res = await dispatch(addCar(data));
    if (res.type === "cars/addCar/fulfilled") {
      success();
      dispatch(getMyCars());
      navigate("/myAccount");

      // form.resetFields();
      // setFile([]);
    }
  };

  return (
    <div className={s.addCar}>
      {contextHolder}
      <div className={s.contentWrapper}>
        <h2 className={s.h2}>
          <PlusCircleOutlined /> &nbsp;
          {`${t("add")} ${t("carSaleApplication").toLowerCase()}`}
        </h2>
        <div className={s.content}>
          <Form
            form={form}
            className={s.form}
            encType='multipart/form-data'
            layout='vertical'
            onFinish={sendForm}
          >
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("category")}
                  name='category'
                  rules={[
                    {
                      required: true,
                      message: t("selectCategory"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("selectCategory")}
                    options={carTypes
                      ?.filter(
                        (el) => el.id !== 4 && el.id !== 6 && el.id !== 7
                      )
                      ?.map((it) => ({
                        value: it?.id,
                        label: it?.name,
                      }))}
                    onSelect={(value) => {
                      setActiveCategory(value);
                      selectSubcategories(value);
                      setActiveSubcategory(undefined);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("type")}
                  name='vechicle_type'
                  rules={[
                    {
                      required: true,
                      message: `${t("select")} ${t("type").toLowerCase()}`,
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("type")}
                    options={activeSubcategories?.map((it) => ({
                      value: it?.id,
                      label: it?.name,
                    }))}
                    value={activeSubCategory}
                    onSelect={(value) => setActiveSubcategory(value)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("brand")}
                  name='brand'
                  rules={[
                    {
                      required: true,
                      message: t("selectBrand"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("selectBrand")}
                    options={brands?.map((it) => ({
                      value: it.id,
                      label: it.name,
                    }))}
                    onSelect={(value) => {
                      setSelectedBrand(value);
                      selectModels(value);
                      setModelValue(undefined);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("model")}
                  name='model'
                  rules={[
                    {
                      required: true,
                      message: `${t("select")} ${t("model").toLowerCase()}`,
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={`${t("select")} ${t("model").toLowerCase()}`}
                    value={modelValue}
                    options={modelsByBrand?.map((it) => ({
                      value: it?.id,
                      label: it?.name,
                    }))}
                    onSelect={(value) => setModelValue(value)}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  name='year'
                  label={t("year")}
                  rules={[
                    {
                      required: true,
                      message: t("selectYear"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("year")}
                    options={years?.map((it) => ({
                      value: it,
                      label: it,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  name='body_type'
                  label={t("bodyType")}
                  rules={[
                    {
                      required: true,
                      message: `${t("select")} ${t("bodyType").toLowerCase()}`,
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={`${t("select")} ${t(
                      "bodyType"
                    ).toLowerCase()}`}
                    options={bodyTypeOptions?.map((it) => ({
                      value: it,
                      label: t(`bodyTypeOptions.${it}`),
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item label={t("generation")} name='generation'>
                  <input placeholder={t("generation")} className={s.input} />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("fuelType")}
                  name='fuel'
                  rules={[
                    {
                      required: true,
                      message: `${t("select")} ${t("fuelType").toLowerCase()}`,
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={`${t("select")} ${t(
                      "fuelType"
                    ).toLowerCase()}`}
                    options={fuelTypesOptions?.map((it) => ({
                      value: it,
                      label: t(`fuelTypeOptions.${it}`),
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("driveType")}
                  name='drive_type'
                  rules={[
                    {
                      required: true,
                      message: `${t("select")} ${t("driveType").toLowerCase()}`,
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={`${t("select")} ${t(
                      "driveType"
                    ).toLowerCase()}`}
                    options={driveTypeOptions?.map((it) => ({
                      value: it,
                      label: t(`driveTypeOptions.${it}`),
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("transmission")}
                  name='transmission'
                  rules={[
                    {
                      required: true,
                      message: t("selectTransmission"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("transmission")}
                    options={transmissionOptions?.map((it) => ({
                      value: it,
                      label: t(`transmissionOptions.${it}`),
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("wheel")}
                  name='wheel'
                  rules={[
                    {
                      required: true,
                      message: t("selectWheel"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("wheel")}
                    options={wheelOptions?.map((it) => ({
                      value: it,
                      label: t(`wheelOptions.${it}`),
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("volume")}
                  name='volume'
                  rules={[
                    {
                      required: true,
                      message: `${t("select")} ${t("volume").toLowerCase()}`,
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={`${t("select")} ${t("volume").toLowerCase()}`}
                    options={fuelVolume?.map((it) => ({
                      value: it,
                      label: it,
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
            <div className={s.subtile}>{t("description")}</div>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("color")}
                  name='color'
                  rules={[
                    {
                      required: true,
                      message: `${t("select")} ${t("color").toLowerCase()}`,
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={`${t("select")} ${t("color").toLowerCase()}`}
                    options={colorsOptions?.map((it) => ({
                      value: it,
                      label: t(`colors.${it}`),
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("condition")}
                  name='condition'
                  rules={[
                    {
                      required: true,
                      message: t("selectCondition"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("condition")}
                    options={conditionOptions?.map((it) => ({
                      value: it,
                      label: t(`conditionOptions.${it}`),
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("mileage")}
                  name='mileage'
                  rules={[
                    {
                      required: true,
                      message: `${t("enter")} ${t("mileage").toLowerCase()}`,
                    },
                  ]}
                >
                  <input
                    placeholder={`${t("enter")} ${t("mileage").toLowerCase()}`}
                    className={s.input}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("available")}
                  name='inStock'
                  rules={[
                    {
                      required: true,
                      message: t("available"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("available")}
                    options={availableOptions?.map((it) => ({
                      value: it,
                      label: t(`availableOptions.${it}`),
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("description")}
                  name='description'
                  rules={[
                    {
                      required: true,
                      message: `${t("add")} ${t("description").toLowerCase()}`,
                    },
                  ]}
                >
                  <ReactQuill value={value} onChange={setValue} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("customControl")}
                  name='customControl'
                  rules={[
                    {
                      required: true,
                      message: t("customControl"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("customControl")}
                    options={[
                      { value: true, label: t("yes") },
                      { value: false, label: t("no") },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("registration")}
                  name='registration'
                  rules={[
                    {
                      required: true,
                      message: t("selectRegistrationCountry"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("registration")}
                    options={locationOptions?.map((it) => ({
                      value: it,
                      label: t(`locationOptions.${it}`),
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item label={t("vincode")} name='vincode'>
                  <input
                    placeholder={`${t("enter")} ${t("vincode").toLowerCase()}`}
                    className={s.input}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item label={t("installment")} name='installment'>
                  <Select
                    className={s.select}
                    placeholder={t("installment")}
                    options={[
                      { value: "yes", label: t("thereIs") },
                      { value: "no", label: t("thereIsNo") },
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("price")}
                  name='price'
                  rules={[
                    {
                      required: true,
                      message: t("selectPrice"),
                    },
                  ]}
                >
                  <input placeholder={t("price")} className={s.input} />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("currency")}
                  name='currency'
                  initialValue={{ value: "usd", label: "USD" }}
                  rules={[
                    {
                      required: true,
                      message: "Выберите валютy",
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("currency")}
                    options={currency}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("phone")}
                  name='phone'
                  rules={[
                    {
                      required: true,
                      message: `${t("enter")} ${t("phone").toLowerCase()}`,
                    },
                  ]}
                >
                  <input placeholder={t("phone")} className={s.input} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  label={t("location")}
                  name='location'
                  rules={[
                    {
                      required: true,
                      message: `${t("select")} ${t("location").toLowerCase()}`,
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={`${t("select")} ${t(
                      "location"
                    ).toLowerCase()}`}
                    options={locations?.map((it) => ({
                      value: it.id,
                      label: it.name,
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={width > 500 ? 12 : 24}>
                <Form.Item
                  initialValue={file}
                  name='images'
                  label={`${t("upload")} ${t("photo").toLowerCase()}`}
                >
                  <Upload
                    listType='picture-card'
                    fileList={file}
                    onPreview={handlePreview}
                    onChange={(e) => setFile(e.fileList)}
                    multiple={true}
                    beforeUpload={() => false}
                  >
                    {uploadButton}
                  </Upload>
                  {previewImage && (
                    <Image
                      wrapperStyle={{
                        display: "none",
                      }}
                      preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) =>
                          !visible && setPreviewImage(""),
                      }}
                      src={previewImage}
                    />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row span={24} className={s.btn_row}>
              <Button className={s.btn} htmlType='submit'>
                <PlusOutlined /> &nbsp;
                {`${t("add")} ${t("auto").toLowerCase()}`}
              </Button>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default AddCar;
